import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import Message from '../../../../common/Message';
import AppInput from '../../../../common/AppInput';
import ProductPreview from '../../../../common/ProductPreview';
import MotiveTitle from '../../../Contact/Motive/MotiveTitle';
import { CHANGE_DATE, COMPLETE_FORM } from '../../../../../constants/texts';
import { useChageDateStyles } from './styles';
import { textMapper } from '../../../../../helpers/FormHelper';
import DatePickers from '../../../../common/DatePickers';
import Loader from '../../../../common/Loader';

const Form = ({ ...props }) => {
  const { state, onData, fields, mobile, motiveId, setShowForm } = props;
  const classes = useChageDateStyles({ mobile });
  const { messages, status, getStatus } = useSelector(
    (state) => state.validationProductSlice,
  );
  const showMessage = messages.length > 0;
  let loadingGif = getStatus === 'loading';

  const disableSundays = (date) => date.day() === 0;

  const minDate = () => {
    const today = new Date();
    const addDay = 24 * 60 * 60 * 1000;
    const minDate = new Date(today.getTime() + addDay);
    return minDate;
  };

  const handleChange = (e) => {
    onData({ name: e.target.name, value: e.target.value });
  };

  const handleDate = (date) => {
    onData({ name: 'expectedDate', value: date });
  };

  useEffect(() => {
    setShowForm(status);
  }, [status]);

  useEffect(() => {
    if (loadingGif) setShowForm(false);
    else setShowForm(status);
  }, [loadingGif]);

  return (
    <React.Fragment>
      <MotiveTitle
        title={textMapper.get(motiveId).title}
        subtitle={textMapper.get(motiveId).subtitle}
        icon={textMapper.get(motiveId).icon}
        mobile={mobile}
      />

      {loadingGif && <Loader mobile={mobile} />}

      {!loadingGif && (
        <React.Fragment>
          <ProductPreview mobile={mobile} />

          <Message
            message={!showMessage ? CHANGE_DATE : messages}
            severity="info"
            fullRounded
          />

          {status && (
            <React.Fragment>
              <Typography className={classes.title}>{COMPLETE_FORM}</Typography>
              {fields.map((field, index) => (
                <React.Fragment key={index}>
                  {!field.hidden && field.inputType !== 'date' && (
                    <AppInput
                      onChange={handleChange}
                      onBlur={() => {}}
                      onClick={() => {}}
                      disabled={state[field.name]?.disabled || false}
                      name={field.name}
                      error={state[field.name]?.error || false}
                      type={state[field.name]?.type || ''}
                      label={state[field.name]?.label || ''}
                      required={state[field.name]?.required || false}
                      inputAdornment={state[field.name]?.inputAdornment || ''}
                      success={state[field.name]?.success || ''}
                      helperText={state[field.name]?.helper || ''}
                      multiline={state[field.name]?.multiline || false}
                      rows={state[field.name]?.rows || ''}
                      value={state[field.name]?.value || ''}
                      errorMessage={state[field.name]?.message || ''}
                    />
                  )}
                  {!field.hidden && field.inputType === 'date' && (
                    <DatePickers
                      onChange={handleDate}
                      name={field.name}
                      label={state[field.name]?.label || ''}
                      required={state[field.name]?.required || false}
                      disabled={state[field.name]?.disabled || false}
                      success={state[field.name]?.success || ''}
                      error={state[field.name]?.error || false}
                      errorMessage={state[field.name]?.message || ''}
                      value={state[field.name]?.value || ''}
                      disablePast={true}
                      disableFuture={state[field.name]?.disableFuture || false}
                      helperText={state[field.name]?.helper || ''}
                      minDate={minDate()}
                      shouldDisableDate={disableSundays}
                    />
                  )}
                </React.Fragment>
              ))}
            </React.Fragment>
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

Form.propTypes = {
  state: PropTypes.object,
  onData: PropTypes.func,
  fields: PropTypes.array,
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  setShowForm: PropTypes.bool,
};

export default Form;
